<template>
  <div
    class="modal fade p-2"
    :class="{ show: isOpen }"
    tabindex="-1"
    :style="{ display: isOpen ? 'block' : 'none' }"
    aria-modal="true"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <font-awesome-icon
            v-if="headerIcon"
            class="modal-icon"
            :icon="`fa-solid ${headerIcon}`"
          />
        </div>
        <div class="modal-body">
          <label v-if="description">{{ description }}</label>
          <slot name="description"></slot>
        </div>
        <div v-if="$slots.footer" class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseModal',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: '',
      required: false
    },
    isOpen: {
      type: Boolean,
      default: false,
      required: true
    },
    headerIcon: {
      type: String,
      default: 'fa-info-circle',
      required: false
    }
  },
  emits: ['update:isOpen'],
  setup(_, { emit }) {
    const setModalVisible = (value: boolean): void => {
      emit('update:isOpen', value);
    };

    return { setModalVisible };
  }
});
</script>

<style lang="scss" scoped>
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em;
  background-color: lightgray;
}
.modal-body {
  padding: 1em;
}
.modal-icon {
  font-size: 1.5rem;
}
.modal.show {
  display: block;
  background: rgba(0, 0, 0, 0.9);
}
</style>
